<template>
  <v-card height="100%" flat>
    <v-toolbar color="indigo" dense height="65px">
      <v-toolbar-title class="white--text"> Benestare </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone per il trasferimento -->
      <v-btn
        @click="clickQRCode('trasferimento')"
        height="55px"
        color="white"
        class="mr-10"
      >
        <div>
          <v-icon class="mb-1" color="primary" size="22px">
            mdi-qrcode-scan
          </v-icon>
          <br />
          <span style="font-size: 13px">Leggi QR code</span>
        </div>
      </v-btn>

      <!-- Bottone per la chiusura -->
      <v-btn @click="clickQRCode('chiusura')" height="55px" color="white">
        <div>
          <v-icon class="mb-1" color="orange" size="22px"
            >mdi-file-edit-outline</v-icon
          ><br />
          <span style="font-size: 13px">Chiudi Commessa</span>
        </div>
      </v-btn>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-container fluid>
      <v-row align="center">
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Data Da"
            type="date"
            v-model="filtro_data_da"
            @keyup.enter="getBenesrtareInsit"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Data A"
            type="date"
            v-model="filtro_data_a"
            @keyup.enter="getBenesrtareInsit"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Cod. Commessa"
            v-model="filtro_commessa"
            @keyup.enter="getBenesrtareInsit"
          >
            <template v-slot:append>
              <v-icon
                @click="filtro_commessa = null"
                color="error"
                v-if="filtro_commessa != null"
              >
                mdi-close
              </v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Cod. Articolo"
            v-model="filtro_cod_articolo"
            @keyup.enter="getBenesrtareInsit"
          >
            <template v-slot:append>
              <v-icon
                @click="filtro_cod_articolo = null"
                color="error"
                v-if="filtro_cod_articolo != null"
              >
                mdi-close
              </v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Seriale"
            v-model="filtro_seriale"
            @keyup.enter="getBenesrtareInsit"
          >
            <template v-slot:append>
              <v-icon
                @click="filtro_seriale = null"
                color="error"
                v-if="filtro_seriale != null"
              >
                mdi-close
              </v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mt-3"
                @click="getBenesrtareInsit"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Cerca</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-data-table
            :headers="headers_benestare"
            :items="items_benestare"
          ></v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog del lettore QR code -->
    <v-dialog v-model="qr_reader_visible" width="75%" persistent>
      <v-toolbar dense color="indigo">
        <v-toolbar-title class="white--text">QR Master</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" v-on="on">
              <v-icon @click="handleCloseQRDialog" color="error">
                mdi-close
              </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <qrcode-stream :camera="camera" @decode="handleOnDecode"></qrcode-stream>
    </v-dialog>

    <!-- Dialog di conferma spostamento -->
    <v-dialog v-model="dialog_conferma_spostamento" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="eseguiSpostamento" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_spostamento = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <div style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler dare il benestare per il master
          </div>
          <div
            class="my-5"
            style="color: rgb(0, 0, 0); font-weight: bold; font-size: 25px"
          >
            {{ computed_seriale }}
          </div>
          <div style="color: rgb(0, 0, 0); font-size: 18px">per l'articolo</div>
          <div
            class="my-5"
            style="color: rgb(0, 0, 0); font-weight: bold; font-size: 25px"
          >
            {{ computed_cod_articolo }}
          </div>
          <div style="color: rgb(0, 0, 0); font-size: 18px">
            per la quantità di
          </div>
          <div
            class="my-5"
            style="color: rgb(0, 0, 0); font-weight: bold; font-size: 25px"
          >
            {{ qta_commessa }}
          </div>
          <div style="color: rgb(0, 0, 0); font-size: 18px">?</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma chiusura commessa -->
    <v-dialog v-model="dialog_conferma_chiusura" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiCommessa" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_chiusura = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <div style="color: rgb(0, 0, 0); font-size: 18px">La commessa</div>

          <div
            class="my-5"
            style="color: rgb(0, 0, 0); font-weight: bold; font-size: 25px"
          >
            {{ cod_commessa_chiusura }}
          </div>

          <div style="color: rgb(0, 0, 0); font-size: 18px">
            può essere chiusa in maniera definitiva. <br />
            Una volta chiusa in maniera definitiva<br />
            non potrà più essere utilizzata.<br />
            Vuoi procedere?
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "Benestare",
  components: { SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      camera: "off",
      cod_commessa_chiusura: null,
      des_um_commessa: null,
      filtro_cod_articolo: null,
      filtro_commessa: null,
      filtro_data_a: null,
      filtro_data_da: null,
      filtro_seriale: null,
      id_articolo_chiusura: null,
      id_commessa_chiusura: null,
      id_stato_chiusura_definitiva: null,
      modalita: "",
      qr_string: "",
      qta_commessa: null,
      request_counter: 0,

      // Modal
      dialog_conferma_chiusura: false,
      dialog_conferma_spostamento: false,
      overlay: false,
      qr_reader_visible: false,

      // Array
      items_benestare: new Array(),
      headers_benestare: [
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
        },
        {
          text: "Commessa",
          value: "cod_commessa",
        },
        {
          text: "Seriale",
          value: "numero_seriale",
        },
        {
          text: "Quantità",
          value: "qta",
        },
      ],
    };
  },
  computed: {
    computed_seriale() {
      if (
        this.qr_string != "" &&
        this.qr_string != null &&
        this.qr_string.includes("(S)") &&
        this.qr_string.includes(";")
      ) {
        return this.qr_string.split("(S)")[1].split(";")[0];
      } else {
        return "";
      }
    },
    computed_cod_articolo() {
      if (
        this.qr_string != "" &&
        this.qr_string != null &&
        this.qr_string.includes("(P)") &&
        this.qr_string.includes(";")
      ) {
        return this.qr_string.split("(P)")[1].split(";")[0];
      } else {
        return "";
      }
    },
  },
  watch: {
    request_counter: {
      immediate: true,
      handler() {
        if (this.request_counter <= 0) {
          this.overlay = false;
        } else {
          this.overlay = true;
        }
      },
    },
  },
  methods: {
    checkChiusura(arg) {
      const seriale = arg.split("(S)")[1].split(";")[0];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkchiusuratrasferimento",
          token: localStorage.user_token,
          seriale: seriale,
        },
      };

      this.request_counter++;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            if (res.data.result[0].chiusura_disponibile == 1) {
              this.cod_commessa_chiusura = res.data.result[0].cod_commessa;
              this.id_commessa_chiusura = res.data.result[0].id_commessa;
              this.id_articolo_chiusura = res.data.result[0].id_articolo;
              this.dialog_conferma_chiusura = true;
            } else {
              const msg =
                res.data.result[0].messaggio_stato != "OK"
                  ? res.data.result[0].messaggio_stato
                  : res.data.result[0].messaggio_quantita != "OK"
                  ? res.data.result[0].messaggio_quantita
                  : "Verificare stato e produzione a magazzino per questa commessa.";
              this.$refs.SnackbarQV.print("orange", msg);
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    checkQRCodeSAP(arg) {
      const cod_articolo = arg.split("(P)")[1].split(";")[0];
      const seriale = arg.split("(S)")[1].split(";")[0];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "checkqrcodesap",
          token: localStorage.user_token,
          cod_articolo: cod_articolo,
          seriale: seriale,
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.qta_commessa = res.data.result[0].quantita;
            this.des_um_commessa = res.data.result[0].des_um;
            this.dialog_conferma_spostamento = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
        });
    },
    chiudiCommessa() {
      this.dialog_conferma_chiusura = false;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo_chiusura,
          id_commessa: this.id_commessa_chiusura,
          id_profilo: localStorage.id_profilo,
          tabella: [
            {
              commessa: [
                {
                  id_commessa: this.id_commessa_chiusura,
                  id_stato: this.id_stato_chiusura_definitiva,
                },
              ],
              commessa_dettaglio: [],
              commessa_distinta: [],
            },
          ],
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Commessa chiusa.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
        });
    },
    clickIndietro() {
      this.$router.push("/home/production");
    },
    clickQRCode(arg) {
      this.modalita = arg;

      // Resetto le variabili.
      this.qr_string = "";
      this.qta_commessa = null;
      this.des_um_commessa = null;
      this.id_articolo_chiusura = null;
      this.id_commessa_chiusura = null;
      this.cod_commessa_chiusura = null;

      // Attivo la videocamera.
      this.qr_reader_visible = true;
      this.camera = "auto";
    },
    async eseguiSpostamento() {
      this.dialog_conferma_spostamento = false;
      const spostamento = await this.spostaInMagazzinoSap(this.qr_string);

      if (spostamento) {
        this.checkChiusura(this.qr_string);
      }
    },
    getBenesrtareInsit() {
      // Controllo che le date siano compatibili.
      if (this.filtro_data_da < this.filtro_data_a) {
        this.$refs.SnackbarQV.print("orange", "Filtri data non compatibili.");
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getbenestareinsit",
          token: localStorage.user_token,
          filtro_data_da: this.filtro_data_da,
          filtro_data_a: this.filtro_data_a,
          filtro_cod_articolo: this.filtro_cod_articolo,
          filtro_cod_commessa: this.filtro_commessa,
          filtro_seriale: this.filtro_seriale,
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.items_benestare = res.data.result ?? [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    getTabella() {
      /* Questa gettabelle mi serve sostanzialmente per
       * essere in grado di riconoscere il tipo di domanda
       * con cui sto lavorando, in modo da configurare debitamente
       * i contenuti dei dialog. */
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "COMMESSA_STATO",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Popolo l'array dei tipi di domanda
            this.id_stato_chiusura_definitiva = res.data.filter(
              (elem) => elem.val_txt == "6"
            )[0]?.id_tabella;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità tecnica rilevata, codice: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    handleCloseQRDialog() {
      this.qr_reader_visible = false;
      this.camera = "off";
    },
    handleOnDecode(arg) {
      if (this.modalita == "trasferimento") {
        this.handleOnDecodeTrasferimento(arg);
      } else if (this.modalita == "chiusura") {
        this.handleOnDecodeChiusura(arg);
      }
    },
    handleOnDecodeChiusura(arg) {
      this.qr_string = arg;
      this.camera = "off";
      this.qr_reader_visible = false;

      this.checkChiusura(this.qr_string);
    },
    handleOnDecodeTrasferimento(arg) {
      this.qr_string = arg;
      this.camera = "off";
      this.qr_reader_visible = false;

      this.checkQRCodeSAP(this.qr_string);
    },
    spostaInMagazzinoSap(arg) {
      const cod_articolo = arg.split("(P)")[1].split(";")[0];
      const seriale = arg.split("(S)")[1].split(";")[0];
      const tipo = arg.split("(T)")[1].split(";")[0];

      // Controllo che l'etichetta sia un master.
      if (tipo != "MASTER") {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'etichetta non è di tipo master."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "spostainmagazzinosap",
          token: localStorage.user_token,
          cod_articolo: cod_articolo,
          seriale: seriale,
        },
      };

      this.request_counter++;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Benestare confermato.");
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            JSON.parse(err?.response?.data?.message)?.result
          );
          return false;
        });
    },
  },
  created() {},
  mounted() {
    this.filtro_data_da = moment().format("YYYY-MM-DD");
    this.filtro_data_a = moment().format("YYYY-MM-DD");
    this.getTabella();
    this.getBenesrtareInsit();
  },
};
</script>
<style scoped>
</style>